import { Job } from 'types/Job'

export const getJobGlobalEvent = (job: Job): string | null => {
  switch (job?.type) {
    case 'activityhistoryreport':
    case 'activityreport':
    case 'allusersaudiousagereport':
    case 'allusersactivityreport':
    case 'allusersconferenceidsreport':
    case 'allusersintegratedaudiousagereport':
    case 'allusersmeetingattendeereport':
    case 'allusersmeetinghistoryreport':
    case 'allusersregistrantreport':
    case 'allusersscheduledmeetingreport':
    case 'alluserswebinarrecordingregistrantreport':
    case 'audiousagereport':
    case 'billinghistoryreport':
    case 'billingratereport':
    case 'meetingattendeereport':
    case 'meetinghistoryreport':
    case 'registrantreport':
    case 'scheduledmeetingreport':
    case 'usersaudiousagereport':
    case 'usersintegratedaudiousagereport':
    case 'webinarrecordingregistrantreport':
    case 'allusersreport':
      return 'REPORT_CREATION' // used in @ucc/unified-admin-core when exporting reports
    case 'setalluserslicenses':
    case 'setlicenseuserslicenses':
    case 'setgroupuserslicenses':
    case 'setuserlicenses':
    case 'licenseallusers':
    case 'licensegroupusers':
    case 'licenselicenseusers':
    case 'licenseusers':
    case 'unlicenseallusers':
    case 'unlicenselicenseusers':
    case 'unlicensegroupusers':
    case 'unlicenseusers':
    case 'groupallusers':
    case 'grouplicenseusers':
    case 'groupgroupusers':
    case 'groupusers':
    case 'ungroupallusers':
    case 'ungrouplicenseusers':
    case 'ungroupgroupusers':
    case 'ungroupusers':
    case 'deleteuser':
      return 'USERS_UPDATED' // used in @ucc/unified-admin-core to refresh the users list when there's an async update
    case 'usersreport':
      return 'USERS_REPORT' // used in @ucc/unified-admin-core when exporting users
    case 'addgroup':
    case 'deletegroup':
      return 'USER_GROUPS_UPDATED'
    default:
  }
  return null
}
